module.exports = __webpack_public_path__ + "img/address1.82206112.png";